import { Overrides } from '@material-ui/core/styles/overrides';

export const MuiCheckboxInput: Overrides['MuiCheckboxInput'] = {
  inputContainer: {
    marginTop: 3, // offset input so it aligns with text
  },
};
